// src/services/chatService.ts
import { config } from '../config/config';
import { api } from './api';

class ChatService {
  private headers: Record<string, string> = {};

  constructor() {
    this.headers = {
      'Content-Type': 'application/json',
    };
  }

  async fetchChats(skip: number = 0, limit: number = 0): Promise<any> {
    try {
      return await api.get(`/chats`, {
        headers: this.headers,
        params: {
          skip: skip,
          limit: limit,
        },
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async fetchMessages(
    chatId: string,
    skip: number = 0,
    limit: number = 0
  ): Promise<any> {
    try {
      return await api.get(`/chats/${chatId}/messages_chunk`, {
        headers: this.headers,
        params: {
          skip: skip,
          limit: limit,
        },
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async createNewChat(): Promise<any> {
    try {
      return await api.post(
        `/chats`,
        {},
        {
          headers: this.headers,
          withCredentials: true,
        }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async generateChatName(chatId: string): Promise<any> {
    try {
      return await api.get(`/chats/${chatId}/generate-name`, {
        headers: this.headers,
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async cancelChat(chatId: string): Promise<void> {
    try {
      await api.post(
        `/chats/${chatId}/cancel`,
        {},
        {
          headers: this.headers,
          withCredentials: true,
        }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async sendMessage(
    chatId: string,
    content: string,
    assistanceMode: any,
    model: any,
    database: any,
    style: any,
    signal: any
  ): Promise<any> {
    try {
      return await fetch(`${config.apiUrl}/chats/${chatId}/send/stream`, {
        headers: this.headers,
        method: 'POST',
        body: JSON.stringify({
          message_content: content,
          assistant_role: assistanceMode,
          model: model,
          database: database,
          style: style,
        }),
        signal: signal,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async editChat(chatId: string, newChatName: string): Promise<void> {
    try {
      await api.put(
        `/chats/${chatId}/name`,
        {
          new_chat_name: newChatName.trim(),
        },
        {
          headers: this.headers,
          withCredentials: true,
        }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async feedbackChat(
    chatId: string,
    rating: number,
    comment: string
  ): Promise<void> {
    try {
      await api.post(
        `/feedback`,
        {
          chat_id: chatId,
          rating: rating,
          comment: comment,
        },
        {
          headers: this.headers,
          withCredentials: true,
        }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async deleteChat(chatId: string): Promise<void> {
    try {
      await api.delete(`/chats/${chatId}`, {
        headers: this.headers,
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async suggestionPrompt(): Promise<any> {
    try {
      return await api.get(`/suggestions`, {
        headers: this.headers,
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export const chatService = new ChatService();
